/**
 */
function isEmptyString(string) {
    return !string || string.length < 1;
}

/**
 */
function isEmptyList(list) {
    return !list || list.length < 1;
}

/**
 */
function isEmptyObj(obj) {
    let arr = Object.getOwnPropertyNames(filterParams(obj));
    return arr.length == 0;
}

/**
 * 是否是手机号码
 */
function isNoMobile(phone) {
    return !phone || !(/^1\d{10}$/.test(phone));
}
/**
 * 是否是手机号码
 */
function isNoAZNum(string) {
    return !string || !(/^[0-9]+$/.test(string));
}

/**
 * 是否是固定电话
 */
function isNoPhone(phone) {
    return !phone || !((/^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/.test(phone)) || (/^(\d{7,8})?$/.test(phone)));
}

/**
 * 是否是邮政编码
 */
function isNoPostalCode(obj) {
    return !obj || !(/^[1-9]{1}[0-9]{5}$/.test(obj));
}

function chkPrice(obj) {//正数
    obj = obj.replace(/[^\d.]/g, "");
    //必须保证第一位为数字而不是.
    obj = obj.replace(/^\./g, "");
    //保证只有出现一个.而没有多个.
    obj = obj.replace(/\.{2,}/g, ".");
    //保证.只出现一次，而不能出现两次以上
    obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    return obj;
}

function chkPositiveInt(obj) {//正整数
    obj = obj + ''
    obj = obj.replace(/^(0+)|[^\d]+/g, '');
    return obj;
}

/**
 * 获取dotNum位小数，默认4位
 */
function getPrice(obj, dotNum = 4) {
    return parseFloat(getPriceString(obj, dotNum))
}

function getPriceString(obj, dotNum = 4) {
    if (isEmptyString(obj))
        return parseFloat('0').toFixed(dotNum)

    obj = obj + ".00000"

    let isNegative = obj.startsWith('-')

    let after = chkPrice(obj)

    if (isEmptyString(after))
        return parseFloat('0').toFixed(dotNum)

    return parseFloat((isNegative ? '-' : '') + after).toFixed(dotNum)
}

function isObjectValueEqual(a, b) {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length != bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i]

        var propA = a[propName]
        var propB = b[propName]
        if (propA !== propB) {
            if ((typeof (propA) === 'object')) {
                if (this.isObjectValueEqual(propA, propB)) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        } else {
            return false
        }
    }
    return true;
}

//这个方法不会影响原来的对象，而是返回一个新对象
function filterParams(obj) {
    let _newPar = {};
    for (let key in obj) {
        //如果对象属性的值不为空，就保存该属性（这里我做了限制，如果属性的值为0，保存该属性。如果属性的值全部是空格，属于为空。）
        if ((obj[key] === 0 || obj[key]) && obj[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
            //记录属性
            _newPar[key] = obj[key];
        }
    }
    //返回对象
    return _newPar;
}
//返回一get字符串
function getParamsString(params) {
    const str = [];
        for (let p in params) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
        }
        let body = null;
        if (str.length > 0) {
            body = str.join("&");
        }
    return body;
}

//判断是否有空参数 filter【】 为需要判断字段数组
function objHasNull(obj,filter=[]) {
    for (let key in obj) {
        if (filter.indexOf(key)!=-1 && obj[key].toString().replace(/(^\s*)|(\s*$)/g, '') === '') {
            return true;
        }
    }
    return false;
}

function log(obj) {
    // return
    console.log(obj)
    // console.log(JSON.stringify(obj))
}

function filter(str) { // 特殊字符转义
    str += ''; // 隐式转换
    str = str.replace(/%/g, '%25');
    str = str.replace(/\+/g, '%2B');
    str = str.replace(/ /g, '%20');
    str = str.replace(/\//g, '%2F');
    str = str.replace(/\?/g, '%3F');
    str = str.replace(/&/g, '%26');
    str = str.replace(/\=/g, '%3D');
    str = str.replace(/#/g, '%23');
    return str;
}

function formateObjToParamStr(paramObj) {
    const sdata = [];
    for (let attr in paramObj) {
        sdata.push(`${attr}=${filter(paramObj[attr])}`);
    }
    return sdata.join('&');
};

function objEnterObj(old, newObj, isFilter) {
    if (isFilter) return filterParams(Object.assign({}, old, newObj))
    return Object.assign({}, old, newObj);
};

function getStringNum(string, num) {
    let res = string.substring(0, num)
    return res;
};

function sortNumber(a, b) {
    return a.id - b.id
}
function deepClone(old, newObj) {
    newObj = JSON.parse(JSON.stringify(old))
    return newObj;
};

/**
 * 解析地址，将完整地址拆分为地址、门牌号和室号
 * @param {string} fullAddress 完整地址，如"杨柳桥路339弄3号1703室"
 * @returns {object} 包含address（地址）、doorNo（门牌号）、roomNo（室号）的对象
 */
function parseAddress(fullAddress) {
    if (!fullAddress) return { address: '', doorNo: '', roomNo: '' };
    
    let address = fullAddress;
    let doorNo = '';
    let roomNo = '';
    
    // 查找"弄"的位置
    const nongIndex = address.indexOf('弄');
    if (nongIndex !== -1) {
        // 提取"弄"之前的部分作为地址
        const baseAddress = address.substring(0, nongIndex + 1);
        const afterNong = address.substring(nongIndex + 1);
        
        // 查找"号"的位置
        const haoIndex = afterNong.indexOf('号');
        if (haoIndex !== -1) {
            // 提取"弄"到"号"之间作为门牌号
            doorNo = afterNong.substring(0, haoIndex + 1);
            
            // 剩余部分查找"室"
            const afterHao = afterNong.substring(haoIndex + 1);
            const shiIndex = afterHao.indexOf('室');
            if (shiIndex !== -1) {
                roomNo = afterHao.substring(0, shiIndex + 1);
            } else {
                // 如果没有"室"，则剩余部分作为室号
                roomNo = afterHao;
            }
        } else {
            // 如果没有"号"，检查是否有"室"
            const shiIndex = afterNong.indexOf('室');
            if (shiIndex !== -1) {
                roomNo = afterNong.substring(0, shiIndex + 1);
            }
        }
        
        return { address: baseAddress, doorNo, roomNo };
    } else {
        // 如果没有"弄"，尝试其他格式
        const haoIndex = address.indexOf('号');
        if (haoIndex !== -1) {
            // 提取"号"之前的部分作为门牌号
            doorNo = address.substring(0, haoIndex + 1);
            const afterHao = address.substring(haoIndex + 1);
            const shiIndex = afterHao.indexOf('室');
            if (shiIndex !== -1) {
                roomNo = afterHao.substring(0, shiIndex + 1);
            } else {
                roomNo = afterHao;
            }
            
            return { address: '', doorNo, roomNo };
        }
    }
    
    // 如果都没有匹配到，返回原始地址
    return { address: fullAddress, doorNo: '', roomNo: '' };
}

export default {
    isEmptyString,
    isEmptyList,
    isEmptyObj,
    isNoMobile,
    isNoAZNum,
    isNoPhone,
    isNoPostalCode,
    chkPositiveInt,
    chkPrice,
    getPrice,
    getPriceString,
    isObjectValueEqual,
    filterParams,
    getParamsString,
    objHasNull,
    log,
    formateObjToParamStr,
    objEnterObj,
    getStringNum,
    sortNumber,
    deepClone,
    parseAddress,
}
